import isFunction from 'lodash/isFunction'

export const dispatchAction = (store, actionList) => {

  actionList.forEach(action => {
    if (isFunction(action.data)) {
      throw new Error('Actions can only receive primitive data types.')
    }

    if (action.data) {
      store.dispatch(action.name, action.data)
    } else {
      store.dispatch(action.name)
    }
  })
}


export default dispatchAction